{
  "valid": "Valido",
  "expired": "Scaduto",
  "month": "{n} mesi | {n} mesi",
  "days": "{n} giorno rimanente | {n} giorni rimanenti",
  "keystore": {
    "generateSelfSignedCertificate": "Genera un certificato autofirmato",
    "generateCSR": "Genera una CSR",
    "csrRequiresUploadCertificate": "Per questa richiesta di firma del certificato è necessario aggiungere un certificato",
    "list": {
      "action": {
        "delete": {
          "description": "Il certificato {alias} verrà eliminato."
        }
      }
    },
    "updateCertificate": "Aggiorna il certificato",
    "csr": "CSR",
    "certificate": "Certificato",
    "error": {
      "csr": {
        "loading": "Errore di caricamento della CSR."
      }
    },
    "automaticRenewal": {
      "label": "Ritardo automatico del certificato",
      "csr": {
        "info": "Il rinnovo automatico sarà avviato ogni giorno se a questo certificato è associata una parametrizzazione PKI. È inoltre possibile attivare immediatamente il rinnovo premendo il pulsante.",
        "buttonLabel": "Genera certificato"
      }
    },
    "filters": {
      "searchByAlias": "Ricerca per alias"
    }
  },
  "download": "Scarica il certificato",
  "delete": "Elimina il certificato",
  "noCertificate": "Nessun certificato disponibile",
  "tag": "Etichetta",
  "tags": {
    "label": "Etichette",
    "empty": "Nessuna etichetta trovata"
  },
  "alias": "Alias",
  "expiration": {
    "timestamp": {
      "label": "Data di scadenza",
      "labelColon": "Data di scadenza:"
    }
  },
  "list": {
    "column": {
      "timestamp": {
        "format": "DD/MM/YYYY alle HH:mm"
      }
    },
    "action": {
      "delete": {
        "description": "Il certificato {alias} verrà eliminato."
      }
    }
  },
  "form": {
    "serialNumber": "Numero di serie",
    "organizationUnit": "Unità di organizzazione",
    "organization": "Organizzazione",
    "locality": "Località",
    "region": "Regione",
    "country": "Paese",
    "tags": {
      "placeholder": "Seleziona",
      "remove": {
        "tooltip": "Fai clic per rimuovere il tag"
      }
    },
    "associatedPkiConfiguration": "Parametrizzazione PKI associata",
    "cn": "CN",
    "email": "E-mail"
  },
  "validation": {
    "alias": {
      "required": "L’alias è obbligatorio.",
      "invalid": "L’alias deve contenere solo lettere minuscole dell’alfabeto latino, numeri, trattini, trattini bassi o spazi."
    },
    "cn": "Il CN è obbligatorio.",
    "email": "L’e-mail è obbligatoria.",
    "certificate": {
      "invalid": "Il certificato non sembra essere stato convalidato.",
      "extension": "Il certificato non contiene l’estensione corretta.",
      "fileEmpty": "Il file non deve essere vuoto.",
      "fileSize": "La dimensione del file non deve superare 750 MB."
    },
    "associatedPkiConfiguration": "Avviso: Il rinnovo automatico del certificato non verrà eseguito finché il certificato/CSR non sarà associato a una parametrizzazione PKI."
  },
  "error": {
    "certificate": {
      "loading": "Errore di caricamento del certificato."
    }
  },
  "truststore": {
    "uploadCertificate": "Aggiungi il certificato",
    "editCertificate": "Modifica il certificato"
  },
  "filters": {
    "searchByAlias": "Ricerca per alias"
  },
  "cancelAction": {
    "confirm": {
      "message": "Annullare questa operazione? Tutti i dati andranno persi."
    }
  },
  "chain": {
    "label": "Catena di certificati",
    "level": "livello {level}"
  },
  "downloadCSR": "Scarica CSR",
  "subject": {
    "label": "Soggetto"
  },
  "subjectAlternativeName": {
    "label": "Nome alternativo del soggetto (SAN)",
    "add": "Aggiungi SAN",
    "empty": "Nessun SAN definito.",
    "delete": "Elimina il SAN",
    "noValue": "Valore mancante",
    "unknownError": "Si è verificato un errore sconosciuto durante la verifica",
    "type": "Tipo",
    "value": "Valore",
    "2": {
      "label": "DNS",
      "labelColon": "DNS:",
      "invalidFormat": "Il valore deve essere un DNS valido"
    },
    "7": {
      "label": "IP",
      "labelColon": "IP",
      "invalidFormat": "Il valore deve essere un indirizzo IP valido"
    }
  },
  "extendedKeyUsage": {
    "label": "Uso esteso della chiave (EKU)",
    "empty": "Nessun EKU definito.",
    "1": "Autenticazione server",
    "2": "Autenticazione client"
  },
  "tab": {
    "keystore": "Keystore",
    "truststore": "Truststore"
  },
  "trustChain": {
    "label": "Catena di certificati"
  },
  "start": {
    "timestamp": {
      "labelColon": "Data di inizio di validità:"
    }
  }
}
